// 토큰 만료 리다이렉트 공통 함수 - apollo, graphFetch 모두 적용
import {reIssuanceAccessToken, signOut} from "../api/rest/authApi";
import { clearStoredUser } from "../utils/localStorageUtils"; // 경로는 상황에 맞게


export const handleTokenExpiration = async () => {
    await signOut();
    clearStoredUser();
    window.location.href = '/login?expired=true';
    throw new Error('Token expired'); // 추가 처리 방지
};

export const ReIssuanceAccessToken = async () => {
    const res = await reIssuanceAccessToken()
    if (res?.status !== 200) { await handleTokenExpiration(); }

    return true
}